import type { JSONValue } from "ai";
import { isMimoModel } from "@/lib/ai/billing-usage";

export type ChatSwitches = {
  thinking: boolean;
  webSearch: boolean;
};

export function modelAllowsThinking(capabilities: readonly string[]) {
  return capabilities.includes("reasoning");
}

export function modelAllowsWebSearch(capabilities: readonly string[]) {
  return capabilities.includes("websearch");
}

export function thinkingRequestBody(
  providerType: string,
  on: boolean,
  modelId = "",
): Record<string, JSONValue> {
  if (isMimoModel(modelId) || isSwitchableThinkingModel(modelId)) {
    return { thinking: { type: on ? "enabled" : "disabled" } };
  }
  switch (providerType) {
    case "deepseek":
    case "zhipu":
      return { thinking: { type: on ? "enabled" : "disabled" } };
    case "tongyi":
      return { enable_thinking: on };
    default:
      return { reasoningEffort: on ? "high" : "none" };
  }
}

function isSwitchableThinkingModel(modelId: string) {
  return /^(?:doubao-seed-2-[01]-(?:pro|lite|mini|turbo|code-preview)|deepseek-v4(?:\.\d+)?-(?:flash|pro))(?:-|$)/i.test(modelId);
}

type ThinkingModel = {
  providerType: string;
  modelId: string;
  capabilities: readonly string[];
  providerOptionsKey: string;
};

export function thinkingProviderOptions(model: ThinkingModel, requested = false) {
  const allowed = modelAllowsThinking(model.capabilities);
  if (!allowed && !isSwitchableThinkingModel(model.modelId) && !isMimoModel(model.modelId)) {
    return undefined;
  }

  return {
    [model.providerOptionsKey]: thinkingRequestBody(
      model.providerType,
      allowed && requested,
      model.modelId,
    ),
  };
}

export function webSearchRequestBody(
  providerType: string,
  modelId = "",
): Record<string, JSONValue> | null {
  if (isMimoModel(modelId)) return {};
  switch (providerType) {
    case "tongyi":
      return { enable_search: true };
    default:
      return null;
  }
}
